import { FC } from 'react';
import { useSelector } from 'react-redux';
import { AdvancedFilterRow } from 'shared/components/AdvancedFilter/components/AdvancedFilterRow';
import { InlineFilter } from 'shared/components/InlineFilter';
import { MaskedInput } from 'shared/components/MaskedInput';
import { useFilterChangeCallback, useDebouncedCallback } from 'shared/hooks';
import { selectContactPhoneFilter } from 'shared/selectors/advancedFilters';

export const ContactPhoneContainer: FC = () => {
  const { label, value } = useSelector(selectContactPhoneFilter);

  const onChange = useFilterChangeCallback();

  const handleContactPhoneChange = useDebouncedCallback(
    (newValue: string) => {
      onChange({ action: 'setContact', arguments: [newValue || null] });
    },
    300,
    [onChange],
  );

  return (
    <AdvancedFilterRow label={label}>
      <InlineFilter>
        <MaskedInput
          width={260}
          placeholder="+7 XXX XXX-XX-XX"
          value={value}
          mask="+7 000 000-00-00"
          onAccept={handleContactPhoneChange}
        />
      </InlineFilter>
    </AdvancedFilterRow>
  );
};
